import React, { Component, Fragment } from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AppURL from '../../api/AppURL';
import axios from 'axios'
import NewArrivalLoading from '../PlaceHolder/NewArrivalLoading';
import { Link } from 'react-router-dom'

class NewArrival extends Component {


     constructor(props) {
          super(props);
          this.state = {
               ProductData: [],
               isLoading: "",
               mainDiv: "d-none"
          }
          this.next = this.next.bind(this);
          this.previous = this.previous.bind(this)
     }
     next() {
          this.slider.slickNext();
     }
     previous() {
          this.slider.slickPrev();
     }


     componentDidMount() {
          axios.get(AppURL.ProductListByRemark("NEW")).then(response => {

               this.setState({
                    ProductData: response.data, isLoading: "d-none",
                    mainDiv: ""
               });

          }).catch(error => {

          });
     }

     render() {


          const NewList = this.state.ProductData;
          const MyView = NewList.map((NewList, i) => {

               if (!NewList.special_price || NewList.special_price === "na") {
                    return <div>
                         <Link className="text-link" to={"/productdetails/" + NewList.id} >
                              <Card className="image-box card">
                                   <img className="center" src={NewList.image} />
                                   <Card.Body>
                                        <p className="product-name-on-card">{NewList.title}</p>
                                        <p className="product-price-on-card">Price : ${NewList.price}</p>
                                   </Card.Body>
                              </Card>
                         </Link>
                    </div>

               }
               else {

                    return <div>
                         <Link className="text-link" to={"/productdetails/" + NewList.id} >
                              <Card className="image-box card">
                                   <img className="center" src={NewList.image} />
                                   <Card.Body>
                                        <p className="product-name-on-card">{NewList.title}</p>
                                        <p className="product-price-on-card">Price : <strike className="text-secondary">${NewList.price}</strike> ${NewList.special_price}</p>

                                   </Card.Body>
                              </Card>
                         </Link>
                    </div>

               }

          });
          //প্রধান সেটিংস
          //dots: false - স্লাইডারের নিচে ডট নেভিগেশন দেখানো হবে না।
          //infinite: true - স্লাইডার লুপে চলতে থাকবে, অর্থাৎ স্লাইডের শেষেও আবার প্রথম স্লাইডে চলে আসবে।
          //speed: 500 - প্রতিটি স্লাইড ট্রানজিশনের সময় ৫০০ মিলিসেকেন্ড (অর্ধ সেকেন্ড)।
          //autoplay: true - স্লাইডার স্বয়ংক্রিয়ভাবে চলবে।
          //autoplaySpeed: 3000 - স্বয়ংক্রিয় স্লাইড পরিবর্তনের সময়ের ব্যবধান ৩০০০ মিলিসেকেন্ড বা ৩ সেকেন্ড।
          //slidesToShow: 4 - প্রতি স্লাইডে একসঙ্গে ৪টি আইটেম দেখানো হবে।
          //slidesToScroll: 1 - প্রতি ট্রানজিশনে ১টি স্লাইড করে স্ক্রল হবে।
          //initialSlide: 0 - প্রথমবার লোডের সময় স্লাইডারের কোন স্লাইডটি প্রদর্শিত হবে, এখানে প্রথম স্লাইড (ইনডেক্স 0) দেখাবে।


          //responsive সেটিংস

          //responsive অ্যারের মাধ্যমে বিভিন্ন স্ক্রিন সাইজের জন্য ভিন্ন ভিন্ন সেটিংস প্রদান করা হয়েছে।

          // Breakpoint: 1024px এবং এর নিচে
          // slidesToShow: 4 - ১০২৪ পিক্সেল বা তার কম স্ক্রিন সাইজে একসঙ্গে ৪টি স্লাইড দেখাবে।
          //slidesToScroll: 1 - প্রতি ট্রানজিশনে ১টি করে স্লাইড স্ক্রল হবে।
          // infinite: true - স্লাইডার চলমান থাকবে।
          //dots: true - ডট নেভিগেশন এখানে সক্রিয় থাকবে।

          // Breakpoint: 600px এবং এর নিচে
          //slidesToShow: 2 - ৬০০ পিক্সেল বা এর কম স্ক্রিনে একসঙ্গে ২টি স্লাইড দেখাবে।
          //slidesToScroll: 1 - প্রতি ট্রানজিশনে ১টি স্লাইড করে স্ক্রল হবে।
          //initialSlide: 2 - প্রথমবার লোডের সময় ২ নম্বর স্লাইড থেকে শুরু হবে।

          // Breakpoint: 480px এবং এর নিচে
          //slidesToShow: 1 - ৪৮০ পিক্সেল বা তার কম স্ক্রিন সাইজে একসঙ্গে ১টি স্লাইড দেখাবে।
          // slidesToScroll: 1 - প্রতি ট্রানজিশনে ১টি স্লাইড করে স্ক্রল হবে।

          var settings = {
               dots: false,
               infinite: true,
               speed: 500,
               autoplay: true,
               autoplaySpeed: 3000,
               slidesToShow: 4,
               slidesToScroll: 1,
               initialSlide: 0,
               arrows: false,
               responsive: [
                    {
                         breakpoint: 1024,
                         settings: {
                              slidesToShow: 4,
                              slidesToScroll: 1,
                              infinite: true,
                              dots: true
                         }
                    },
                    {
                         breakpoint: 600,
                         settings: {
                              slidesToShow: 2,
                              slidesToScroll: 1,
                              initialSlide: 2
                         }
                    },
                    {
                         breakpoint: 480,
                         settings: {
                              slidesToShow: 1,
                              slidesToScroll: 1
                         }
                    }
               ]
          };


          return (
               <Fragment>

                    <NewArrivalLoading isLoading={this.state.isLoading} />

                    <div className={this.state.mainDiv}>
                         <Container className="text-center" fluid={true}>
                              <div className="section-title text-center mb-55"><h2>NEW ARRIVAL &nbsp;

                                   <a className="btn btn-sm ml-2 site-btn" onClick={this.previous} ><i className="fa fa-angle-left"></i></a>
                                   &nbsp;
                                   <a className="btn btn-sm ml-2 site-btn" onClick={this.next} ><i className="fa fa-angle-right"></i></a>

                              </h2>
                                   <p>Some Of Our Exclusive Collection, You May Like</p>
                              </div>

                              <Row>

                                   {/* ref={c => (this.slider = c)} এটি Slider কম্পোনেন্টের রেফারেন্স this.slider এ সংরক্ষণ করে। রেফারেন্সের মাধ্যমে আপনি Slider কম্পোনেন্টের বিশেষ বৈশিষ্ট্য বা 
                                   মেথডগুলি সরাসরি অ্যাক্সেস করতে পারবেন।   */}

                                   <Slider ref={c => (this.slider = c)} {...settings}>
                                        {MyView}

                                   </Slider>

                              </Row>


                         </Container>
                    </div>

               </Fragment>
          )
     }
}

export default NewArrival
